import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "manage" }
const _hoisted_2 = {
  key: 0,
  class: "scroll"
}
const _hoisted_3 = { class: "topbar" }
const _hoisted_4 = {
  key: 0,
  class: "logo"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "flex v-center center main full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_loader_display = _resolveComponent("loader-display")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.order)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.logourl)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("img", { src: _ctx.logourl }, null, 8, _hoisted_5)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_router_view)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_loader_display)
        ]))
  ]))
}